import { shallowRef } from 'vue';

import fetchPlans, { type ParsedPlan } from '~/modules/worry-no-more/services/PlansService';
import useSelectedPlan from './useSelectedPlan';
import { useWnm } from './useWnm';

export default function usePlans() {
  const plans = shallowRef<ParsedPlan | null>(null);
  const { isProductBigTicket } = useWnm();
  const { planType } = useSelectedPlan();

  async function fetch(): Promise<void> {
    if (planType.value && !plans.value) {
      plans.value = await fetchPlans(planType.value, isProductBigTicket.value);
    }
  }

  return { fetch, plans };
}
